import {
  CREATE_RELAY_CONTROLLER_STATUS_HISTORY,
  DELETE_RELAY_CONTROLLER_STATUS_HISTORY,
  EDIT_RELAY_CONTROLLER_STATUS_HISTORY,
  RECEIVE_LIMITED_RELAY_CONTROLLER_STATUS_HISTORIES,
  RECEIVE_RELAY_CONTROLLER_STATUS_HISTORIES,
  REQUEST_RELAY_CONTROLLER_STATUS_HISTORY,
  REQUEST_RELAY_CONTROLLER_STATUS_HISTORY_FOR_UNIT_WITH_RANGE,
} from '@sophocles/entities/RelayControllerStatusHistory/relayControllerStatusHistoryActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAY_CONTROLLER_STATUS_HISTORIES: // Read
      return state.merge(action.relayControllerStatusHistories);
    case RECEIVE_LIMITED_RELAY_CONTROLLER_STATUS_HISTORIES:
      return action.relayControllerStatusHistories.merge(state);
    case DELETE_RELAY_CONTROLLER_STATUS_HISTORY: // Delete
      return state.delete(action.relayControllerStatusHistory.toString());
    case EDIT_RELAY_CONTROLLER_STATUS_HISTORY: // Update
    case CREATE_RELAY_CONTROLLER_STATUS_HISTORY: // Create
    case REQUEST_RELAY_CONTROLLER_STATUS_HISTORY:
    case REQUEST_RELAY_CONTROLLER_STATUS_HISTORY_FOR_UNIT_WITH_RANGE:
    default:
      return state;
  }
}

export function relayControllerStatusHistoryReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RELAY_CONTROLLER_STATUS_HISTORY:
    case DELETE_RELAY_CONTROLLER_STATUS_HISTORY:
    case RECEIVE_RELAY_CONTROLLER_STATUS_HISTORIES:
    case EDIT_RELAY_CONTROLLER_STATUS_HISTORY:
    case REQUEST_RELAY_CONTROLLER_STATUS_HISTORY:
    case REQUEST_RELAY_CONTROLLER_STATUS_HISTORY_FOR_UNIT_WITH_RANGE:
    case RECEIVE_LIMITED_RELAY_CONTROLLER_STATUS_HISTORIES:
      return getState(state, action);
    default:
      return state;
  }
}
